<template>
    <v-toolbar app class="primary"  dark clipped-left>
        <v-flex xs4 v-if="isMobile && $route.meta.showMenu">
            <v-toolbar-side-icon 
                aria-label="OpenMenu" 
                @click.stop="drawer()"
            ></v-toolbar-side-icon>
        </v-flex>
        <v-flex xs12>
            <v-toolbar-title class="pt-1">
                <h1>{{$t('views.'+$route.meta.title)}}</h1>
            </v-toolbar-title>
        </v-flex>
        <v-flex xs4 style="text-align:right">
            <select v-model="$i18n.locale" class="language-picker">
                <option v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" :value="locale">{{ locale }}</option>
            </select>
        </v-flex>     
    </v-toolbar>
</template>

<script>
export default {
    name: 'Toolbar',
    data(){
        return {
            almanaccoImageUrl:null,
            almanaccoDescription: null,
            showAlmanaccoDialog: false
        };
    },
    computed: {
        appTitle () {
            let vm = this;
            return vm.$store.state.app.title
        }
    },
    methods: {
        drawer () {
            let vm = this;
            vm.$store.commit('drawer', !vm.$store.state.app.drawer)
        },
    },
    mounted(){
        let vm=this;
    }
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Kalam:wght@300&display=swap');
</style>